import React from 'react'
import PropTypes from 'prop-types'
import StackableImage from '../../../../leap/components/stackable-image'
import EngravingStackableImage from '../engraving-stackable-image'
import ZoomImage from '../../../../leap/components/zoomImage/zoomImage'

const WIDTHS = {
    true: {
        base: '100vw',
        s: '100vw'
    },
    false: {
        base: '100vw',
        s: '60vw'
    }
}

/**
 * Renders the configured XPDP gallery item for standard gallery and zoom overlay contexts.
 *
 * @param {object} props Component props.
 * @param {object} props.product Product data used by the stackable image renderer.
 * @param {object} props.stack Image stack configuration.
 * @param {boolean} props.isExpanded Whether the item is rendered in the full-size zoom overlay.
 * @param {boolean} props.isZoomEnabled Whether the item supports inline zoom.
 * @param {Function} props.onClick Callback invoked when the gallery item is activated.
 * @returns {JSX.Element} Gallery item.
 */
const XpdpConfiguratorGalleryItem = ({
    product,
    stack,
    isExpanded = false,
    isZoomEnabled = false,
    onClick
}) => {
    const isEngraving = product.c_isEngraving
    const Component = isEngraving ? EngravingStackableImage : StackableImage
    const extraProps = isEngraving ? {engraveText: product.variationValues?.text, isExpanded} : {}

    const item = (
        <Component
            {...stack}
            product={product}
            widths={WIDTHS[isExpanded]}
            aspectRatio={isExpanded ? 'auto' : '1/1'}
            // transparent product renders must stay fully visible, never cropped
            objectFit="contain"
            height={isExpanded ? '100%' : undefined}
            onClick={onClick}
            {...extraProps}
        />
    )

    return isZoomEnabled ? <ZoomImage imageName={product.name}>{item}</ZoomImage> : item
}

XpdpConfiguratorGalleryItem.propTypes = {
    product: PropTypes.object,
    stack: PropTypes.object,
    isExpanded: PropTypes.bool,
    isZoomEnabled: PropTypes.bool,
    onClick: PropTypes.func
}

export default XpdpConfiguratorGalleryItem
